module.exports = __webpack_public_path__ + "img/vip-banner-bg.78486ef6.png";